import PublicHeader from '../components/PublicHeader.jsx';
import Footer from '../components/Footer.jsx';
import { CHANGELOG, CURRENT_VERSION } from '../lib/changelog.js';
import { useTitle } from '../lib/useTitle.js';
import { useMetaTags } from '../lib/useMetaTags.js';

export default function Changelog() {
  useTitle('Changelog');
  useMetaTags({
    description: `What changed in TrainForge, release by release. Current version v${CURRENT_VERSION}: AI workout programs, nutrition coaching, trainer tools, and the hands-free glasses app.`,
    ogTitle: 'TrainForge changelog',
    ogDescription: `Every TrainForge release, newest first. Currently v${CURRENT_VERSION}.`,
    ogType: 'website',
    canonical: 'https://mytrainforge.com/changelog',
  });
  return (
    <div>
      <PublicHeader />
      <div className="shell" style={{ maxWidth: 640 }}>
        <h1>Changelog</h1>
        <p style={{ color: 'var(--text-dim)', marginTop: 0 }}>
          Current version: <b style={{ color: 'var(--text)' }}>v{CURRENT_VERSION}</b>
        </p>

        {CHANGELOG.map((entry) => (
          <section key={entry.version} style={{ marginBottom: 24, paddingBottom: 24, borderBottom: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 8 }}>
              <span style={{ fontSize: 12, padding: '2px 8px', background: 'var(--bg-elev)', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)' }}>
                v{entry.version}
              </span>
              <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{entry.date}</span>
            </div>
            <h3 style={{ margin: '0 0 8px' }}>{entry.title}</h3>
            <ul style={{ padding: '0 0 0 16px', margin: 0, display: 'flex', flexDirection: 'column', gap: 4, fontSize: 14, color: 'var(--text-dim)' }}>
              {entry.items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </section>
        ))}

        <Footer />
      </div>
    </div>
  );
}
